import { DataPickerCst } from "@components/InputCst";
import { Box, Grid, useTheme } from "@mui/material";
import {
  CreateTemplate,
  Step5Props,
} from "@pages/Contents/Corporate/CollectCampaigns/types";
import React from "react";
import { useTranslation } from "react-i18next";
import { useCollectCampaignState } from "../../context/CollectCampaignContext";
import DownloaderUploaderCst from "@components/DownloaderUploaderCst";
import { downloadFile, ServicesURL } from "@utils/utilsApi";
import { useParams } from "react-router-dom";
import { useFetchTable } from "@hooks/useFetchDataTable";
import { PagesID } from "@utils/utilsConfigurations";
import { type Dayjs } from "dayjs";

const Step5: React.FC<Step5Props> = ({ errors }) => {
  const { id, idCampaign } = useParams();
  const theme = useTheme();
  const { t } = useTranslation(["collect-campaign-page"]);
  const { state, dispatch } = useCollectCampaignState();
  const { columns } = useFetchTable(
    null,
    PagesID["corporate.collect-campaign.add.template"],
  );

  return (
    <Box
      sx={{
        // backgroundColor: theme.palette.background.paper,
        padding: "16px",
        // borderRadius: "3px",
        // border: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Grid
        container
        spacing={3.75}
        sx={{
          justifyContent: "space-between",
        }}
      >
        {columns?.map((col) => {
          const key = col.accessorKey as keyof CreateTemplate;
          if (col.type === "dateTime") {
            return (
              <Grid key={col.accessorKey} item xs={12} sm={6}>
                <DataPickerCst
                  key={col.accessorKey}
                  id={col.accessorKey}
                  label={col.header}
                  value={state.template?.data?.[key]}
                  required={col.required}
                  onChange={(value) => {
                    const newVal = value as Dayjs | undefined;
                    const dateVal = newVal
                      ? new Date(
                          Date.UTC(
                            newVal.year(),
                            newVal.month(),
                            newVal.date(),
                          ),
                        )
                      : undefined;
                    dispatch({
                      type: "SET_TEMPLATE",
                      payload: {
                        ...state.template,
                        data: {
                          ...state.template?.data,
                          [key]: dateVal,
                        },
                      },
                    });
                  }}
                  error={!!errors[col.accessorKey]}
                  errorMessage={`${t(`validation.${errors[col.accessorKey]}`)}`}
                  disabled={col.disabled}
                />
              </Grid>
            );
          }
          if ((col.type as string) === "upload") {
            return (
              <Grid key={col.accessorKey} item xs={12}>
                <DownloaderUploaderCst
                  name={`${t("upload_template")}`}
                  id={col.accessorKey}
                  accept={"*"}
                  type={["upload", "download", "template"]}
                  downloadDisabled={!idCampaign}
                  fileName={
                    idCampaign ? "certificate_template_archive.zip" : ""
                  }
                  onChange={(e) =>
                    dispatch({
                      type: "SET_TEMPLATE",
                      payload: { ...state.template, zip: e ?? undefined },
                    })
                  }
                  onTemplateDownload={() => {
                    downloadFile(
                      ServicesURL.downloadCampaignCertificateDefaultTemplate
                        .replace(":corporateId", id ? id : "1")
                        .replace(":unit", state.general?.unit ?? "HOURS"),
                      false,
                      "certificate_template_archive.zip",
                      { Accept: "application/zip", responseType: "blob" },
                    );
                  }}
                  onDownload={() => {
                    if (idCampaign) {
                      downloadFile(
                        ServicesURL.downloadCampaignCertificateTemplate
                          .replace(":corporateId", id ? id : "1")
                          .replace(":campaignId", idCampaign ?? ""),
                        false,
                        "certificate_template_archive.zip",
                        { Accept: "application/zip", responseType: "blob" },
                      );
                    }
                  }}
                  showError={!!errors[col.accessorKey]}
                  errorMessage={`${t(`validation.${errors[col.accessorKey]}`)}`}
                />
              </Grid>
            );
          }
          return <></>;
        })}
      </Grid>
    </Box>
  );
};

export default Step5;
